import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon, PhoneIcon } from 'lucide-react';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Products',
    href: '#products'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`} data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-[60px] md:h-[72px]" data-id="element-110">
        {/* Logo */}
        <a href="#home" className={`text-lg sm:text-xl md:text-2xl font-bold tracking-tight transition-colors whitespace-nowrap ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-111">
          Scottsdale Patio Shades
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-112">
          {navLinks.map(link => <a key={link.name} href={link.href} className={`text-sm font-medium transition-colors hover:text-gold ${isScrolled ? 'text-charcoal' : 'text-white/90'}`} data-id="element-113">
              {link.name}
            </a>)}
        </nav>

        {/* Desktop Right Actions */}
        <div className="hidden lg:flex items-center gap-6" data-id="element-114">
          <a href="tel:602-551-1539" className={`flex items-center gap-2 text-sm font-semibold transition-colors hover:text-gold ${isScrolled ? 'text-charcoal' : 'text-white'}`} data-id="element-115">
            <PhoneIcon className="w-4 h-4" data-id="element-116" />
            602-551-1539
          </a>
          <a href="#contact" className="bg-gold hover:bg-gold-hover text-charcoal font-semibold px-6 py-2.5 rounded-full transition-colors text-sm" data-id="element-117">
            Book Now
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className={`lg:hidden p-2 -mr-2 min-w-[44px] min-h-[44px] flex items-center justify-center transition-colors ${isScrolled ? 'text-charcoal' : 'text-white'}`} onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-118">
          {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-119" /> : <MenuIcon className="w-6 h-6" data-id="element-120" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-x-0 top-[60px] bottom-0 bg-white z-40 lg:hidden transition-transform duration-300 ease-in-out ${isMobileMenuOpen ? 'translate-y-0' : '-translate-y-full pointer-events-none'}`} data-id="element-121">
        <div className="flex flex-col p-6 gap-4 h-full overflow-y-auto pb-24" data-id="element-122">
          <nav className="flex flex-col gap-1" data-id="element-123">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-xl font-semibold text-charcoal py-3 min-h-[48px] flex items-center border-b border-gray-100" data-id="element-124">
                {link.name}
              </a>)}
          </nav>

          <div className="mt-auto flex flex-col gap-3 pt-6" data-id="element-125">
            <a href="tel:602-551-1539" className="flex items-center justify-center gap-2 text-lg font-semibold text-charcoal py-4 min-h-[48px] bg-sand rounded-xl" data-id="element-126">
              <PhoneIcon className="w-5 h-5 text-gold" data-id="element-127" />
              602-551-1539
            </a>
            <a href="#contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-gold text-charcoal text-center font-bold text-lg py-4 min-h-[48px] rounded-xl" data-id="element-128">
              Book a Free Consultation
            </a>
          </div>
        </div>
      </div>
    </header>;
}